// src/App.js
import React from 'react';
import './App.css';
import UploaderForm from './UploaderForm';

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <h1>Upload Pet Image</h1>
                <UploaderForm />
            </header>
        </div>
    );
}

export default App;